module.exports = __webpack_public_path__ + "static/media/facebook.9f840c97.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/socials/facebook.svg
// module id = 200
// module chunks = 0